import "core-js/features/map";

import "./index.css";
import vacherinStyle from "./mapstyles.json";
import MapControl from "./map/MapControl";
import { createTable, updateData } from "./components/table.js";
import { createFilter } from "./components/filter";
import { cleanURL } from "./helpers/cleanUrl";

let GMAP_KEY = "";
const GMAP_URL = () =>
  `https://maps.googleapis.com/maps/api/js?key=${GMAP_KEY}&callback=initMap`;
let CENTER = { lat: 46.76, lng: 7.1 };
let ZOOM = 10;
const defaultFilter = "all";

// var
let container;
let map;
let mapControl;
let storesInfos;
let storesLocales;

/**
 * create content info window
 */
const createInfoWindow = d => {
  let type;
  switch (true) {
    case d.online === true && d.automate === false:
      type = "online";
      break;
    case d.online === false && d.automate === true:
      type = "automate";
      break;
    case d.online === true && d.automate === true:
      type = "all";
      break;
    default:
      type = "all";
      break;
  }
  let t = "";
  d.urls.forEach(
    url => (t += `<a target="_blank" href="${url}">${cleanURL(url)}</a><br />`)
  );

  return `<div class="gm_infoWindow_store type_${type}">
            <strong>${d.title}</strong><br />
            ${d.address}<br />
            ${d.city}<br /><br />
            ${t}
         </div>`;
};

/**
 * move to marker on click row
 * @param {Event} e
 */
const handlerClickRow = e => {
  const { currentTarget } = e;
  const { title } = currentTarget.dataset;
  mapControl.moveToMarker(title);
};

/**
 * filter data on change filter selection
 * @param {Event} e
 */
const handlerFilter = e => {
  const value = e.target.value;
  const stores = storesInfos.filter(s => {
    if (value === "all") {
      return s.automate === true || s.online === true;
    } else if (value === "automate") {
      return s.automate === true;
    } else if (value === "online") {
      return s.online === true;
    }
  });
  // add lines to table
  updateData(stores, storesLocales, handlerClickRow);
  // reset markers list
  mapControl.addMarkerOnMap(stores, createInfoWindow);
  mapControl.setZoom(ZOOM);
};

/**
 *  init widget
 */
const init = () => {
  // get variable global values
  storesInfos = window.storesInfos;
  storesLocales = window.storesLocales;
  // map variables
  GMAP_KEY = window.gmap_key || GMAP_KEY;
  CENTER = window.centerDefault || CENTER;
  ZOOM = window.zoomDefault || ZOOM;

  // create script for map library
  const script = document.createElement("script");
  script.setAttribute("src", GMAP_URL());
  script.setAttribute("async", true);
  script.setAttribute("defer", true);
  document.head.appendChild(script);

  // find app container
  container = document.getElementById("online_shop");
  if (container) {
    // filters
    const filters = createFilter(storesLocales, defaultFilter, handlerFilter);
    container.appendChild(filters);
    // create map container
    const mapDiv = document.createElement("div");
    mapDiv.id = "map";
    container.appendChild(mapDiv);
    // table
    const table = createTable(storesLocales);
    container.appendChild(table);
  }
  // add lines to table
  updateData(storesInfos, storesLocales, handlerClickRow);
};

/**
 * init map
 */
const initMap = () => {
  map = new google.maps.Map(document.getElementById("map"), {
    center: CENTER,
    zoom: ZOOM,
    mapTypeId: "vacherinStyle",
    streetViewControl: false
  });

  // add styles to map
  map.mapTypes.set(
    "vacherinStyle",
    new google.maps.StyledMapType(vacherinStyle, { name: "Vacherin Style" })
  );

  // create map
  mapControl = new MapControl();
  mapControl.setMap(map);
  // add all markers on map
  mapControl.addMarkerOnMap(storesInfos, createInfoWindow);
};

window.initMap = initMap;

window.addEventListener("DOMContentLoaded", init);
